import * as React from 'react'

import { Product } from 'even-ts-static'

import { Fields } from 'embed/constants/fields'

import { ApplicationField } from 'embed/components/ApplicationField/container'

const styles = require('./styles')

export const PersonalInfoFields = () => (
  <div className={styles.container}>
    <ApplicationField product={Product.LifeInsurance} field={Fields.FirstName} />
    <ApplicationField product={Product.LifeInsurance} field={Fields.LastName} />
    <ApplicationField product={Product.LifeInsurance} field={Fields.EmailAddress} />
    <ApplicationField product={Product.LifeInsurance} field={Fields.PhoneNumber} />
  </div>
)
